import z from "zod";

export const CopyEquipamentoMedicaoSchema = z.object({
  equipamento: z.string({ required_error: "Informe o nome do equipamento!" }).trim().min(1, "Informe o nome do equipamento!"),
  tipoRespEquipamento: z.union([z.literal(0), z.literal(1)]).default(0),
  idFuncionarioResp: z.number().nullable().optional(),
  descResponsavelResp: z.string().trim().optional(),
}).superRefine((form, ctx) => {
  if (form.tipoRespEquipamento === 1) {
    if (!form.descResponsavelResp) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["descResponsavelResp"],
        message: "Informe o nome do responsável!",
      });
    }
  } else if (!form.idFuncionarioResp || !Number.isInteger(form.idFuncionarioResp) || form.idFuncionarioResp < 1) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["idFuncionarioResp"],
      message: "Selecione o responsável!",
    });
  }
});

export type CopyEquipamentoMedicaoForm = z.infer<typeof CopyEquipamentoMedicaoSchema>;
